var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 32,
    viewBox: "0 0 41 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3555 17C35.3555 18.8385 34.9933 20.659 34.2898 22.3576C33.5862 24.0561 32.555 25.5995 31.255 26.8995C29.9549 28.1995 28.4116 29.2307 26.713 29.9343C25.0145 30.6379 23.194 31 21.3555 31",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35547 17C5.35547 18.8385 5.71759 20.659 6.42116 22.3576C7.12472 24.0561 8.15595 25.5995 9.45597 26.8995C10.756 28.1995 12.2993 29.2307 13.9979 29.9343C15.6965 30.6379 17.517 31 19.3555 31",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3555 1C23.194 1 25.0145 1.36212 26.713 2.06569C28.4116 2.76925 29.9549 3.80048 31.255 5.1005C32.555 6.40053 33.5862 7.94387 34.2898 9.64243C34.9933 11.341 35.3555 13.1615 35.3555 15",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3578 15.6901C36.1267 16.0278 35.6656 16.1142 35.3279 15.8831L29.8247 12.1165C29.487 11.8853 29.4006 11.4242 29.6317 11.0865C29.8628 10.7488 30.324 10.6624 30.6617 10.8935L35.5534 14.2416L38.9015 9.3499C39.1326 9.0122 39.5938 8.92581 39.9315 9.15694C40.2692 9.38808 40.3556 9.84922 40.1244 10.1869L36.3578 15.6901Z",
    fill: "#2E2E2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50946 15.7842C6.22158 15.4934 5.75243 15.491 5.46158 15.7788L0.721964 20.4701C0.431117 20.758 0.428714 21.2272 0.716596 21.518C1.00448 21.8089 1.47363 21.8113 1.76448 21.5234L5.97747 17.3533L10.1475 21.5663C10.4354 21.8572 10.9046 21.8596 11.1954 21.5717C11.4862 21.2838 11.4887 20.8147 11.2008 20.5238L6.50946 15.7842Z",
    fill: "#2E2E2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3555 1C17.517 1 15.6965 1.36212 13.9979 2.06569C12.2993 2.76925 10.756 3.80048 9.45597 5.1005C8.15595 6.40053 7.12472 7.94387 6.42116 9.64243C5.71759 11.341 5.35547 13.1615 5.35547 15",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.8555,
    y: 9,
    width: 2.75757,
    height: 4.66059,
    rx: 1.24504,
    stroke: "#C63031",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.0176C16 17.2506 16.4225 16.6224 17.0355 16.3917C18.0526 16.009 19.2662 15.6602 20.2333 15.6602C21.2005 15.6602 22.414 16.009 23.4312 16.3917C24.0441 16.6224 24.4666 17.2506 24.4666 18.0176V21.2723H16V18.0176Z",
    stroke: "#C63031",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.708eec9bdd64e0331fbe26e5458b117e.svg";
export { ForwardRef as ReactComponent };